import React, { useEffect, useState } from "react";
import api, { fmtErr } from "../../lib/api";
import { fmtDate } from "../../lib/format";
import { Card } from "../ui/card";
import { Badge } from "../ui/badge";
import { Button } from "../ui/button";
import { Smartphone, Copy, KeyRound, Trash2 } from "lucide-react";
import { toast } from "sonner";

const URL_INVIO = `${process.env.REACT_APP_BACKEND_URL}/api/condividi`;

const Copiabile = ({ label, value, testid }) => (
  <div className="space-y-1">
    <div className="text-xs text-muted-foreground">{label}</div>
    <div className="flex gap-2 items-center">
      <code className="flex-1 bg-muted rounded px-2 py-1 text-xs break-all" data-testid={testid}>{value}</code>
      <Button size="sm" variant="outline" onClick={() => { navigator.clipboard.writeText(value); toast.success("Copiato"); }} data-testid={`${testid}-copy`}><Copy className="w-3 h-3" /></Button>
    </div>
  </div>
);

const PASSI = [
  "Apri l'app «Comandi» su iPhone → «+» → rinomina in «Invia a Capital Control».",
  "Tocca «i» (Dettagli) → attiva «Mostra nel foglio di condivisione» → tipi: File, PDF, Immagini.",
  "Aggiungi l'azione «Ripeti con ogni elemento» con «Input comando rapido».",
  "Dentro il ciclo aggiungi «Ottieni contenuti dell'URL»: incolla l'indirizzo qui sopra, Metodo POST.",
  "Intestazioni: aggiungi «X-CC-Chiave» con la chiave qui sopra.",
  "Corpo della richiesta: «Modulo» → aggiungi campo di tipo File, nome «file», valore «Elemento ripetuto».",
  "Dopo il ciclo aggiungi «Mostra notifica» con «Risultati ripetizione»: vedrai cosa ha capito l'Assistente.",
  "Fatto: da WhatsApp, Mail, File o Foto → Condividi → «Invia a Capital Control».",
];

export default function ComandoRapidoPanel() {
  const [s, setS] = useState(null);
  const [chiave, setChiave] = useState(null);
  const load = () => api.get("/condividi/stato").then((r) => setS(r.data)).catch(() => {});
  useEffect(() => { load(); }, []);
  if (!s) return null;
  const genera = async () => {
    if (s.attiva && !window.confirm("Generare una nuova chiave? Quella attuale smetterà di funzionare e andrà aggiornata nel Comando rapido.")) return;
    try { const r = await api.post("/condividi/chiave"); setChiave(r.data.chiave); load(); } catch (e) { toast.error(fmtErr(e.response?.data?.detail)); }
  };
  const revoca = async () => { if (!window.confirm("Revocare la chiave? Il Comando rapido smetterà di funzionare.")) return; await api.delete("/condividi/chiave"); setChiave(null); load(); toast.success("Chiave revocata"); };
  return (
    <Card className="p-4 space-y-3" data-testid="comando-rapido-panel">
      <div className="flex flex-wrap items-center justify-between gap-2">
        <div className="font-semibold flex items-center gap-2"><Smartphone className="w-4 h-4" /> Comando rapido iPhone — invia file all'Assistente da «Condividi»</div>
        <Badge variant="outline" data-testid="comando-rapido-stato">{s.attiva ? `Chiave attiva ····${s.finale}` : "Nessuna chiave"}</Badge>
      </div>
      <div className="text-xs text-muted-foreground">I file arrivano nella chat «Da iPhone» dell'Assistente e in «Da confermare»: l'AI li legge (F24, fatture, atti…) e propone dove archiviarli. {s.attiva && <>File ricevuti: <b>{s.n_file}</b> · Ultimo invio {s.ultimo_uso ? fmtDate(s.ultimo_uso) : "—"}</>}</div>
      <div className="flex gap-2">
        <Button size="sm" onClick={genera} data-testid="comando-rapido-genera"><KeyRound className="w-3 h-3 mr-1" /> {s.attiva ? "Genera nuova chiave" : "Genera chiave"}</Button>
        {s.attiva && <Button size="sm" variant="outline" onClick={revoca} data-testid="comando-rapido-revoca"><Trash2 className="w-3 h-3 mr-1" /> Revoca</Button>}
      </div>
      {chiave && <div className="rounded border border-amber-300 bg-amber-50 p-3 space-y-2" data-testid="comando-rapido-chiave-box">
        <div className="text-xs text-amber-800">Copia la chiave adesso: per sicurezza non verrà più mostrata.</div>
        <Copiabile label="Chiave personale (X-CC-Chiave)" value={chiave} testid="comando-rapido-chiave" />
      </div>}
      <Copiabile label="Indirizzo di invio" value={URL_INVIO} testid="comando-rapido-url" />
      <ol className="list-decimal pl-5 text-xs space-y-1" data-testid="comando-rapido-passi">{PASSI.map((p) => <li key={p}>{p}</li>)}</ol>
    </Card>
  );
}
